export default __webpack_public_path__ + "static/media/ic-tooltip.468818da.svg";